import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SellerDetail } from '../seller.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'app-seller-detail',
  templateUrl: './seller-detail.component.html',
  styleUrls: ['./seller-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SellerDetailComponent implements OnInit {
  username = localStorage.getItem('username');

  sellerForm: FormGroup;
  logo: string | ArrayBuffer;
  isHeadOffice = false;
  errorMessage: string = null;

  @Input() sellerDetail: SellerDetail;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.logo = this.sellerDetail ? this.sellerDetail.logo : null;

    this.sellerForm = this.formBuilder.group({
      nameTH: [this.sellerDetail ? this.sellerDetail.name_th : null, Validators.required],
      nameEN: [this.sellerDetail ? this.sellerDetail.name_en : null],
      taxID: [this.sellerDetail ? this.sellerDetail.tax_id : null, Validators.required],
      branchCode: [this.sellerDetail ? this.sellerDetail.branch_code : null, Validators.required],
      branchName: [this.sellerDetail ? this.sellerDetail.branch_name : null, Validators.required],
      addressTH: [this.sellerDetail ? this.sellerDetail.address_th : null, Validators.required],
      addressEN: [this.sellerDetail ? this.sellerDetail.address_en : null],
      postalCode: [this.sellerDetail ? this.sellerDetail.post_code : null, Validators.required]
    });

    if (this.sellerDetail && this.sellerDetail.branch_code === '00000') {
      this.isHeadOffice = true;
      this.setHeadOffice();
    }
  }

  setHeadOffice() {
    if (this.isHeadOffice) {
      this.branchCode.setValue('00000');
      this.branchName.setValue('HQ');

      this.branchCode.disable();
      this.branchName.disable();
    } else {
      this.branchCode.setValue(this.sellerDetail ? this.sellerDetail.branch_code : null);
      this.branchName.setValue(this.sellerDetail ? this.sellerDetail.branch_name : null);

      this.branchCode.enable();
      this.branchName.enable();
    }
  }

  fileToBase64(file: File) {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => { resolve(reader.result) }
      reader.onerror = () => { reject(new Error('Unable to read')) }
    });
  }

  async onLogoChange(event: any) {
    const file = event.target.files[0];

    this.logo = await this.fileToBase64(file);
  }

  submit() {
    this.errorMessage = null;
    if (this.sellerForm.valid) {
      const data = {
        name_th: this.nameTH.value || '',
        name_en: this.nameEN.value || '',
        tax_id: this.taxID.value || '',
        branch_code: this.branchCode.value || '',
        branch_name: this.branchName.value || '',
        address_th: this.addressTH.value || '',
        address_en: this.addressEN.value || '',
        post_code: this.postalCode.value || '',
        logo: this.logo || ''
      };

      // get API by operation
      const api = this.sellerDetail ? this.apiService.updateSellerBranch(this.sellerDetail.id, data) : this.apiService.createSellerBranch(data);

      api.pipe(
        finalize(() => {
          this.sellerDetail ? this.sniff('UPDATE_SELLER', data.name_th) : this.sniff('CREATE_SELLER', data.name_th);
        })
      ).subscribe(
        () => {
          this.activeModal.close('Submit');
        },
        (err: any) => {
          console.log(err);
          this.errorMessage = err.error.detail;
        }
      );
    }
  }

  sniff(action: string, target: string) {
    const data = {
      action: action,
      address: 'MANAGE_SELLER',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }

  get nameTH() {
    return this.sellerForm.get('nameTH');
  }

  get nameEN() {
    return this.sellerForm.get('nameEN');
  }

  get taxID() {
    return this.sellerForm.get('taxID');
  }

  get branchCode() {
    return this.sellerForm.get('branchCode');
  }

  get branchName() {
    return this.sellerForm.get('branchName');
  }

  get addressTH() {
    return this.sellerForm.get('addressTH');
  }

  get addressEN() {
    return this.sellerForm.get('addressEN');
  }

  get postalCode() {
    return this.sellerForm.get('postalCode');
  }

  get previewDetail() {
    const detail = {
      name_th: this.nameTH.value,
      name_en: this.nameEN.value,
      tax_id: this.taxID.value,
      address_th: this.addressTH.value,
      address_en: this.addressEN.value,
      post_code: this.postalCode.value
    }

    return detail;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-detail/seller-detail.component.ts